import React from "react";
import Navbar from "../components/Navbar";
import Slider from "../components/Slider";
import About from "../components/About";
import Service from "../components/Service";
import TestimonialSection from "../components/TestimonialSection";
import HowToSellSection from "../components/HowToSellSection";
import BlogSection from "../components/BlogSection";


function Home() {
  return (
    <>
      <Navbar />
      <Slider />
      <About />
      <Service />
      <TestimonialSection />
      <HowToSellSection />   {/* ← render it here */}
      <BlogSection />
    </>
  );
}

export default Home;
